import { BRAND_LOGOS } from "@/data/site";

export const BrandsMarquee = () => {
  const loop = [...BRAND_LOGOS, ...BRAND_LOGOS];
  return (
    <div className="marquee-mask overflow-hidden">
      <div className="flex w-max animate-marquee items-center gap-4">
        {loop.map((b, i) => (
          <div
            key={`${b.name}-${i}`}
            className="flex h-20 min-w-[180px] items-center justify-center rounded-xl border border-slate-200 bg-white px-8"
            title={b.name}
          >
            {b.logo ? (
              <img
                src={b.logo}
                alt={`${b.name} logo`}
                loading="lazy"
                className="max-h-10 w-auto object-contain"
              />
            ) : (
              <span className="whitespace-nowrap font-display text-lg font-semibold tracking-tight text-[#334E68]">
                {b.name}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
